import messages from '../../../locale/messages';
import { inputTextLimit, inputDescLimit } from '../../../helpers/inputTextLimit';

const validate = values => {
    const errors = {};

    if (values?.signupGridTitle1) {
        let errorAppSectionTitle = [];
        if (values?.signupGridTitle1?.map((item, index) => {
            const appSectionError = {}
            if (!item?.value || item?.value?.toString().trim() === '') {
                appSectionError.value = messages.required;
                errorAppSectionTitle[index] = appSectionError;
            } else if (item?.value?.length > inputTextLimit) {
                appSectionError.value = messages.inputTextLimitError;
                errorAppSectionTitle[index] = appSectionError;
            }

            if (!item?.description || item?.description?.toString().trim() === '') {
                appSectionError.description = messages.required;
                errorAppSectionTitle[index] = appSectionError;
            } else if (item?.description?.length > inputDescLimit) {
                appSectionError.description = messages.inputDescLimitError;
                errorAppSectionTitle[index] = appSectionError;
            }

            if (!item?.language || item?.language.toString().trim() === '') {
                appSectionError.language = messages.required;
                errorAppSectionTitle[index] = appSectionError;
            }
        }));
        if (errorAppSectionTitle?.length > 0) errors.signupGridTitle1 = errorAppSectionTitle;
    }

    if (!values?.signupGridLink1) {
        errors.signupGridLink1 = messages.required
    } else if (values?.signupGridLink1.trim() == '') {
        errors.signupGridLink1 = messages.required
    } else if (values?.signupGridLink1) {
        if (!/^(?:(?:https?|ftp):\/\/)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:\/\S*)?$/i.test(values?.signupGridLink1)) {
            errors.signupGridLink1 = messages.validUrl;
        }
    }

    if (!values?.signupGridLink2) {
        errors.signupGridLink2 = messages.required
    } else if (values?.signupGridLink2.trim() == '') {
        errors.signupGridLink2 = messages.required
    } else if (values?.signupGridLink2) {
        if (!/^(?:(?:https?|ftp):\/\/)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:\/\S*)?$/i.test(values.signupGridLink2)) {
            errors.signupGridLink2 = messages.validUrl;
        }
    }

    return errors;
};

export default validate;